// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".overlay[data-v-85acf400] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  color: #fff;\n  font-weight: bold;\n  text-transform: uppercase;\n  text-align: center;\n  z-index: 100;\n  opacity: 0.8;\n  background-color: #f3f3f3;\n}", ""]);
// Exports
module.exports = exports;
